/**
 * Supplier / airline remarks from Tripjack /review `messages[]` (Audit L1).
 */
import React from 'react';
import { Info } from 'lucide-react';

function normalizeMessages(formConditions) {
  const raw = formConditions?.messages;
  if (!Array.isArray(raw) || raw.length === 0) return [];
  return raw
    .map((item) => {
      if (typeof item === 'string') return { message: item.trim() };
      if (!item || typeof item !== 'object') return null;
      const message = (item.message || item.text || '').trim();
      if (!message) return null;
      return {
        type: item.type ? String(item.type) : null,
        message,
      };
    })
    .filter(Boolean);
}

export default function ReviewMessagesBanner({ formConditions, testIdSuffix = '' }) {
  const items = normalizeMessages(formConditions);
  if (!items.length) return null;

  return (
    <div
      className="rounded-lg border border-sky-200 bg-sky-50 px-3 py-2.5 text-sm text-sky-950"
      data-testid={`review-messages-banner${testIdSuffix ? `-${testIdSuffix}` : ''}`}
      role="note"
    >
      <div className="flex items-start gap-2">
        <Info className="w-4 h-4 flex-shrink-0 mt-0.5 text-sky-700" />
        <div className="min-w-0 flex-1">
          <p className="font-semibold text-sky-900 text-xs uppercase tracking-wide mb-1">
            Airline / supplier notice
          </p>
          <ul className="space-y-1 list-disc list-inside text-xs leading-relaxed">
            {items.map((row, idx) => (
              <li key={`${row.type || 'msg'}-${idx}`}>
                {row.type && (
                  <span className="font-semibold text-sky-800 mr-1">[{row.type}]</span>
                )}
                {row.message}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
